// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import locationData from './data/locationData.json'
import store from './store.js'
import VueGtm from 'vue-gtm'
import metaContent from './data/meta.json'
import axios from 'axios'
Vue.config.productionTip = false
Vue.prototype.$http = axios

Vue.use(VueGtm, {
  id: process.env.CONFIG.name === 'production' ? 'GTM-NCP9CN5' : 'GTM-5JMH4BW',
  enabled: window.location.host.indexOf('remembear.com') > -1, // disabled for prerender-spa-plugin
  debug: false
  // vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

Vue.mixin({
  data () {
    return {
      ENV: process.env.CONFIG,
      locations: locationData,
      external: {
        twitterUrl: 'https://www.twitter.com/remembear',
        facebookUrl: 'https://www.facebook.com/RememBearApp',
        instagramUrl: 'https://www.instagram.com/TunnelBear',
        help: 'https://help.remembear.com',
        downloadLinks: {
          windows64: 'https://s3.amazonaws.com/remembear/app/release/downloads/windows/RememBear_x64.exe',
          windows32: 'https://s3.amazonaws.com/remembear/app/release/downloads/windows/RememBear_x86.exe',
          mac: 'https://remembear.s3.amazonaws.com/app/release/downloads/macOS/RememBear.dmg',
          ios: 'https://itunes.apple.com/app/remembear-password-manager/id1145554431',
          android: 'https://play.google.com/store/apps/details?id=com.remembear.android',
          chrome: 'https://chrome.google.com/webstore/detail/remembear/ehpbfbahieociaeckccnklpdcmfaeegd',
          safari: 'https://remembear.s3.amazonaws.com/app/release/downloads/macOS/RememBear.dmg', // same as mac
          firefox: 'https://addons.mozilla.org/en-US/firefox/addon/remembear-app/'
        }
      }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (metaContent[to.name]) {
    document.title = metaContent[to.name].title
  } else {
    document.title = metaContent.default.title
  }

  if (to.path.slice(-1) === '/' && to.path.length > 1) {
    let pathWithoutSlash = to.path.substring(0, to.path.length - 1)
    next({ path: pathWithoutSlash, query: to.query, hash: to.hash, meta: to.meta, params: to.params })
    return
  } else if (to.name === 'login' && store.getters.isLoggedIn) {
    next({name: 'overview'})
    return
  } else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn) {
      if (to.name === 'upgrade' && to.query.token) {
        next()
        return
      } else {
        store.commit('saveNextRoute', to)
        next({
          name: 'login'
        })
        return
      }
    }
  }
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js